import cn from "classnames";
import type { ComponentPropsWithRef, FC } from "react";
import "./Input.css";

interface InputProps extends ComponentPropsWithRef<"input"> {
  error?: string;
}

export const Input: FC<InputProps> = (props) => {
  const { error, className, ...rest } = props;

  return <input className={cn("input", className)} {...rest} />;
};
